import React from 'react';
import { Box, Card, CardContent, Typography, Skeleton, useTheme } from '@mui/material';
import { fontWeight } from '../../utils/accounting/styles';

const STATUS_PALETTE = {
  OPEN: 'info',
  IN_PROGRESS: 'warning',
  ON_HOLD: 'warning',
  COMPLETED: 'success',
  INVOICED: 'secondary',
  PARTIALLY_INVOICED: 'info',
  CANCELLED: 'error',
  PENDING_REVIEW: 'secondary',
  PAID: 'success',
  DRAFT: 'info',
  FINAL: 'primary',
  VOID: 'error',
};

const ProTableStats = ({ cards = [], loading = false }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
      {cards.map((card, i) => {
        const paletteKey = card.status ? STATUS_PALETTE[card.status] || 'primary' : null;
        const valueColor = card.color
          ? card.color
          : paletteKey
          ? `${paletteKey}.main`
          : card.highlight
            ? 'primary.main'
            : 'text.primary';

        return (
          <Card
            key={i}
            variant="outlined"
            sx={{
              flex: '1 1 0',
              minWidth: 120,
              cursor: card.onClick ? 'pointer' : 'default',
              borderLeft: card.highlight ? `3px solid ${theme.palette.primary.main}` : undefined,
              '&:hover': card.onClick ? { borderColor: 'primary.main' } : {},
            }}
            onClick={card.onClick}
          >
            <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 }, textAlign: 'center' }}>
              {loading ? (
                <Skeleton width="60%" height={28} sx={{ mx: 'auto' }} />
              ) : (
                <Typography
                  sx={{
                    fontSize: '1.25rem',
                    fontWeight: fontWeight.bold,
                    color: valueColor,
                    lineHeight: 1.3,
                  }}
                  noWrap
                >
                  {card.value}
                </Typography>
              )}
              <Typography
                sx={{
                  fontSize: '0.6875rem',
                  color: 'text.secondary',
                  fontWeight: fontWeight.normal,
                  lineHeight: 1.2,
                  mt: 0.25,
                }}
              >
                {card.label}
              </Typography>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

export default ProTableStats;
